module.exports = __webpack_public_path__ + "static/media/02.955b7739.png";